/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import axios from 'axios';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import Slider from 'react-slick';
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";

class CafeMenuSlide extends PureComponent {
  state = {};
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { colSerial } = this.props.childProps;
    if (colSerial === 0) {
    } else {
      this._getCafeMenu(colSerial);
    }
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    // return false 하면 업데이트를 안함
    return this.props.childProps.colSerial !== nextProps.childProps.colSerial;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.childProps.colSerial !== nextProps.childProps.colSerial) {
      this._getCafeMenu(nextProps.childProps.colSerial);
      window.scrollTo(0, 0);
    }
  };
  _getCafeMenu = async (colSerial) => {
    const result = await this._getCafeMenuApi(colSerial);
    const intReturn = result.data[0].intReturn;
    const cafeSlide = result.data[0].listData;
    //console.log(cafeSlide)
    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          cafeSlide,
        });
      }
    }
  };
  _getCafeMenuApi = (colSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/cafeMenuSlide', {
        params: {
          colSerial: colSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderSlide = () => {
    const { cafeSlide } = this.state;
    const list = cafeSlide.map((item, index) => {
      return <img key={index} src={item.img} alt="" />;
    });

    return list;
  };
  _onNext = () => {
    //this.slider.slickNext()

    this.slider.slickGoTo(1);
  };
  _onPrev = () => {
    //this.slider.slickPrev()
    this.slider.slickGoTo(0);
  };
  render() {
    const { cafeSlide } = this.state;
    const { colSerial } = this.props.childProps;
    const { imgUrl } = this.props;

    var settings = {
      dots: false,
      dotsClass: 'slick-dots slick-thumb',
      infinite: true,
      //speed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      //speed: 3000,
      pauseOnFocus: true,
      //fade: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };
    return (
      <Fragment>
        <div className="slide_layer">
          {parseInt(colSerial) === 18 ? (
            <Fragment>
              <a style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                <img src={imgUrl + '/img/collabocafe/slide_pre1.png'} />
              </a>
              <a style={{ cursor: 'pointer' }} onClick={this._onNext}>
                <img src={imgUrl + '/img/collabocafe/slide_next1.png'} />
              </a>
            </Fragment>
          ) : parseInt(colSerial) === 25 ? (
            <Fragment>
              <a style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                <img src={imgUrl + '/img/collabocafe/slide_menuPre.png'} />
              </a>
              <a style={{ cursor: 'pointer' }} onClick={this._onNext}>
                <img src={imgUrl + '/img/collabocafe/slide_menuNext.png'} />
              </a>
            </Fragment>
          ) : parseInt(colSerial) === 27 ? (
            <Fragment>
              <a style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                <img src={imgUrl + '/img/collabocafe/slide_pre2.png'} />
              </a>
              <a style={{ cursor: 'pointer' }} onClick={this._onNext}>
                <img src={imgUrl + '/img/collabocafe/slide_next2.png'} />
              </a>
            </Fragment>
          ) : parseInt(colSerial) === 31 ? (
            <Fragment>
              <a style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                <img src={imgUrl + '/img/collabocafe/slide_pre.png'} />
              </a>
              <a style={{ cursor: 'pointer' }} onClick={this._onNext}>
                <img src={imgUrl + '/img/collabocafe/slide_food.png'} />
              </a>
            </Fragment>
          ) : (
            <Fragment>
              <a style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                <img src={imgUrl + '/img/collabocafe/slide_pre.png'} />
              </a>
              <a style={{ cursor: 'pointer' }} onClick={this._onNext}>
                <img src={imgUrl + '/img/collabocafe/slide_next.png'} />
              </a>
            </Fragment>
          )}

          <div className="slide_img">
            <Slider ref={(ref) => (this.slider = ref)} {...settings}>
              {cafeSlide ? this._renderSlide() : null}
            </Slider>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(CafeMenuSlide)));
